@let cta = ctaData$ | async;

<section
  (click)="ctaTrigger$.next(true)"
  (keyup.enter)="ctaTrigger$.next(true)"
  [attr.tabindex]="cta !== null && theme !== PromoTheme.FULL_BG ? 0 : null"
  [class.promo-cta]="theme !== PromoTheme.FULL_BG && cta !== null"
  class="promo-card relative fill grow no-underline overflow-hidden flex flex--column-reverse flex--space-between"
  [class.white-bg]="theme === PromoTheme.WHITE"
  [class.nordic-blue-900-bg]="theme === PromoTheme.BLUE"
  [class.black-bg]="theme === PromoTheme.BLACK"
  [class.white-text]="theme !== PromoTheme.WHITE"
  [class.nordic-blue-900-text]="theme === PromoTheme.WHITE"
  [class.border]="
    theme === PromoTheme.WHITE && !(theme === PromoTheme.WHITE && (imageData$ | async) !== null && !isDouble)
  "
  [class.full-width]="fullWidth"
  data-testid="promo-card-container"
>
  <section
    *ngIf="data$ | async as article"
    class="pr-small no-decoration fill promo-card-content flex flex--column flex--space-between flex-1"
    data-testid="promo-card-text-container"
    [class.z1]="isTextOnTop"
  >
    <div>
      <div
        class="flex mr-clear-y ps-small-b promo-card-heading"
        data-testid="promo-card-heading"
        [class.ps-small-b]="!price"
      >
        <fcom-icon
          *ngIf="article?.localSettings?.iconName"
          class="icon-medium ms-xsmall-r"
          [category]="article?.localSettings?.iconCategory ?? IconLibrary.SVG_LIBRARY"
          [name]="article?.localSettings?.iconName"
        />

        <h3 class="mr-clear-y" [class.font-heading-5]="isProductPromo" [class.white-text]="theme !== PromoTheme.WHITE">
          {{ article.title || article.teaserTitle }}
        </h3>
      </div>
      <span [innerHTML]="article.teaserText"></span>
    </div>

    @if (isProductPromo && (price || originalPrice)) {
      <div class="flex flex--middle">
        @if (!originalPrice && pricePrefix) {
          <span class="font-body-2 ms-xxsmall-r">{{ pricePrefix }}</span>
        }
        @if (originalPrice) {
          <span class="heather-700-text font-heading-4" data-testid="promo-card-product-price">
            {{ price | finPrice }}
          </span>
        }
        <div class="flex flex--middle">
          <span
            [ngClass]="{
              'font-body-1 ps-xsmall-l strike-through': originalPrice,
              'font-heading-4': !originalPrice,
              'ps-xxsmall-r': aviosPrice,
            }"
            class="promo-card-product-original-price"
            data-testid="promo-card-product-original-price"
            >{{ originalPrice ?? price | finPrice }}</span
          >
          @if (aviosPrice) {
            <span class="font-body-1 medium-type flex flex--middle" data-testid="product-card-avios-price">
              /
              <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
              {{ aviosPrice }}
              {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
            </span>
          }
        </div>

        @if (originalPrice && fullWidth && (isMobile$ | async) === false) {
          <fcom-tag [theme]="TagTheme.POPULAR" class="ps-xsmall-l" data-testid="promo-card-campaign-tag-full-width">
            <fcom-icon class="icon-small ms-xsmall-r" [name]="SvgLibraryIcon.DISCOUNT_BLOCK" />
            {{ 'campaign.badge' | finLocalization }}
          </fcom-tag>
        }
      </div>
    }

    @if (cta !== null) {
      <div class="ps-medium-t" [ngClass]="!isProductPromo ? 'flex flex--end' : ''">
        @if (cta?.url?.includes('auth.finnair.com')) {
          <fcom-button
            [text]="cta?.title"
            [theme]="
              PromoTheme.WHITE === theme
                ? ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE
                : PromoTheme.FULL_BG === theme
                  ? ButtonTheme.DARK_PRIMARY_NORDIC_BLUE
                  : ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER
            "
            (clickBtn)="openLoginDialog($event)"
          />
        } @else {
          <fcom-button
            [text]="cta?.title"
            [theme]="
              cta?.theme ??
              (PromoTheme.WHITE === theme
                ? ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE
                : PromoTheme.FULL_BG === theme
                  ? ButtonTheme.DARK_PRIMARY_NORDIC_BLUE
                  : ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER)
            "
            [href]="cta?.url"
            [icon]="cta?.icon"
            [externalLink]="cta?.url?.startsWith('http')"
            [openInNewTab]="cta?.openInNewTab"
            (clickBtn)="$event.preventDefault()"
            [loading]="cta?.status === ButtonState.UPDATING"
            [mode]="isProductPromo ? ButtonMode.FILL : ButtonMode.INLINE"
            [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
          />
        }
      </div>
    }
  </section>
  @if (imageData$ | async; as imageData) {
    <section
      [class.full-image]="theme === PromoTheme.FULL_BG"
      [class.promo-image]="theme !== PromoTheme.FULL_BG && !isProductPromo"
      [class.product-promo-image]="isProductPromo"
      class="relative fill overflow-hidden"
    >
      @if ((!fullWidth || (isMobile$ | async)) && originalPrice) {
        <fcom-tag
          [theme]="TagTheme.POPULAR"
          class="ps-xsmall-l absolute promo-tag"
          data-testid="promo-card-campaign-tag"
        >
          <fcom-icon class="icon-small ms-xsmall-r" [name]="SvgLibraryIcon.DISCOUNT_BLOCK" />
          {{ 'campaign.badge' | finLocalization }}
        </fcom-tag>
      }
      @if (!imageData.error) {
        <fcom-lqip-image
          class="fill"
          [fillParent]="true"
          [imageData]="imageData"
          [alt]="imageData.alt"
          [ratio]="aspectRatio"
          [scale]="true"
        />
      }
    </section>
  }
</section>
